export const capitalizeFirstLetter = (str?: string): string | undefined => {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : undefined
}

export const removeDoubleQuotes = (str: string): string => {
    if (str.startsWith('"') && str.endsWith('"')) {
        return str.slice(1, -1)
    }
    return str
}

export const convertToSentenceCase = (str: string): string => {
    if (!str) return str

    // Check if it contains underscores (snake_case)
    if (str.includes('_')) {
        // Split by underscores, join with spaces, and convert to sentence case
        const words = str.split('_').map((word) => word.toLowerCase())
        return words.join(' ').charAt(0).toUpperCase() + words.join(' ').slice(1)
    }

    // Check if it's camelCase (has uppercase letters in the middle)
    if (/[a-z][A-Z]/.test(str)) {
        // Split camelCase into words by inserting space before uppercase letters
        const withSpaces = str.replace(/([a-z])([A-Z])/g, '$1 $2')
        return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1).toLowerCase()
    }

    // Otherwise, just apply sentence case (capitalize first letter, lowercase the rest)
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
